import React, { useState } from 'react';
import { Button, ButtonGroup, Card, Col, Container, ListGroup, Row } from 'react-bootstrap';

import InsuranceExamples_DATA from "./insurance-data-documents/BUSINESS_CyberLiability_v01_Demo.json"


type PetInsuranceExample = {
  id: number;
  title: string;
  scenario: string;
  protection: string;
  photoUrl: string;
};




const petInsuranceExamplesX: PetInsuranceExample[] = [
  {
    id: 1,
    title: "Accidental Injury Treatment",
    scenario: "Your dog is hit by a car and requires emergency surgery and hospitalization.",
    protection: "Pet insurance covers surgery, anesthesia, and post-op care up to the policy limit.",
    photoUrl: "https://images.unsplash.com/photo-1558788353-f76d92427f16?auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 2,
    title: "Chronic Illness Care",
    scenario: "Your cat is diagnosed with diabetes and needs ongoing medication and vet visits.",
    protection: "Covers a portion of medication and treatment for chronic conditions.",
    photoUrl: "https://images.unsplash.com/photo-1592194996308-7b43878e84a6?auto=format&fit=crop&w=400&q=80"
  },
  {
    id: 3,
    title: "Emergency Vet Visit",
    scenario: "Your pet suddenly stops eating and requires emergency diagnostic testing.",
    protection: "Insurance helps pay for emergency exam fees, tests, and treatment.",
    photoUrl: "https://images.unsplash.com/photo-1601758003122-58e2acb0c8ce?auto=format&fit=crop&w=400&q=80"
  }
  // Add more entries as needed
];

const InsuranceExample3: React.FC = () => {
  const [view, setView] = useState<'card' | 'list'>('list');

  return (
    <Container className="my-4">
      <h2 className="mb-4 text-center">How {InsuranceExamples_DATA.title} Insurance Protects You</h2>

      <div className="text-center mb-4">
        <ButtonGroup>
         
          <Button
            variant={view === 'list' ? 'primary' : 'outline-primary'}
            onClick={() => setView('list')}
            >
            List View
          </Button>
            <Button
            variant={view === 'card' ? 'primary' : 'outline-primary'}
            onClick={() => setView('card')}
            >
            Card View
          </Button>
        </ButtonGroup>
      </div>

      {view === 'card' ? (
        <Row>
          {InsuranceExamples_DATA.examples.map((example) => (
            <Col md={6} lg={4} className="mb-4" key={example.id}>
              <Card className="h-100 shadow-sm">
                {/* 
                <Card.Img
                  variant="top"
                  src={example.photoUrl}
                  alt={example.title}
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = "https://via.placeholder.com/400x300?text=Image+Not+Available";
                  }}
                /> 
                */}
                <Card.Body>
                  <Card.Title>{example.id}. {example.title}</Card.Title>
                  <Card.Text><strong>Scenario:</strong> {example.scenario}</Card.Text>
                  <Card.Text><strong>Protection:</strong> {example.protection}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <ListGroup>
          {InsuranceExamples_DATA.examples.map((example) => (
            <ListGroup.Item key={example.id}>
              <h5>{example.id}. {example.title}</h5>
              <p><strong>Scenario:</strong> {example.scenario}</p>
              <p><strong>Protection:</strong> {example.protection}</p>
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </Container>
  );
};

export default InsuranceExample3;
